import React, { useState, useEffect } from 'react';

import { cooperplaceApi } from 'services/api';
import { validatePermission } from 'actions/index';
import useQuery from 'hooks/useQuery';
import ApplicationLayout from 'v3/layouts/Application';
import { useSnackbar } from 'v3/components/Snackbar';
import InfiniteScroll from 'v3/components/InfiniteScroll';

import { usePermission } from 'hooks';

import { Col } from 'react-bootstrap';

import {
  Text,
  Space,
  Button,
  Link
} from 'v3/components';

import Card from '../../Card';
import Filter from '../../Components/Filter';

export default function BlacklistList() {

  usePermission('VISUALIZAR_BLACKLIST', { redirect: true });

  const snackbar = useSnackbar();
  const queryParams = useQuery();
  const [loading, setLoading] = useState(true);
  const [blacklistItems, setBlacklistItems] = useState([]);
  const [pagination, setPagination] = useState({
    last_page: 1,
    current_page: 1,
    total: 0,
  });

  const [advancedFilters, setAdvancedFilters] = useState({
    blacklistType: null,
    clientTaker: [],
    driver: [],
    shippingCompany: [],
    wagon: [],
    vehicle: [],
    active: -1,
    reason: '',
  });

  const [showAdvancedFiltersModal, setShowAdvancedFiltersModal] = useState(false);
  const [qtdAdvancedFilters, setQtdAdvancedFilters] = useState(0);

  const [hasPermissionToCreate, setHasPermissionToCreate] = useState(false);

  async function loadBlacklistItems(page = 1) {
    if (page === 1) {
      setLoading(true);
    }
    try {
      const response = await cooperplaceApi.get(`blacklist?page=${page}&${queryParams}`);
      const { data, meta } = response.data;

      if (data) {
        setBlacklistItems(oldData => {
          if (page == 1) return data;
          return [...oldData, ...data]
        });
        setPagination(meta);
      } else {
        setBlacklistItems([]);
        setPagination({
          last_page: 1,
          current_page: 1,
          total: 0,
        });
      }

    } catch {
      snackbar.show(<Text>Algo deu errado, tentar novamente mais tarde</Text>, { type: 'error' });
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    setHasPermissionToCreate(validatePermission('CADASTRAR_BLACKLIST'));
    loadBlacklistItems();
  }, []);

  function renderItem(item) {
    return <Card blacklistItem={item} />;
  }

  return (
    <ApplicationLayout
      title="Blacklist"
      RightComponent={
        <Col style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          gap: '0.5rem'
        }}>
          <Space x="0.25rem" y="0.25rem">
            <Button
              variant="secondary"
              onClick={() => setShowAdvancedFiltersModal(true)}
              disabled={loading}
            >
              <Text
                weight={500}
              >{`Filtro Avançado (${qtdAdvancedFilters})`}</Text>
            </Button>
          </Space>
          {
            hasPermissionToCreate && (
              <Link withoutIcon="true" to="/blacklist/cadastrar">
                <Button variant="primary">
                  <Text weight={500} color="white" type="regular">
                    Cadastrar
                  </Text>
                </Button>
              </Link>
            )
          }
        </Col>
      }
    >
      <Filter
        onChange={() => loadBlacklistItems()}
        showAdvancedFiltersModal={showAdvancedFiltersModal}
        setShowAdvancedFiltersModal={setShowAdvancedFiltersModal}
        setQtdAdvancedFilters={setQtdAdvancedFilters}
        qtdAdvancedFilters={qtdAdvancedFilters}
        queryParams={queryParams}
        setAdvancedFilters={setAdvancedFilters}
        advancedFilters={advancedFilters}
        loading={loading}
      />
      <InfiniteScroll
        data={blacklistItems}
        renderItem={renderItem}
        onEndReach={() => loadBlacklistItems(pagination?.current_page + 1)}
        hasMore={pagination?.current_page < pagination?.last_page}
        scrollThreshold={0.7}
        loading={loading}
      />
    </ApplicationLayout>
  );
}
